import { catchError, EMPTY, Observable, tap } from "rxjs";
import { IUserService } from "shared/services/data/user/user-service.interface";
import { IAuthService } from "shared/services/infrastructure/authentication/auth-service.interface";
import { LoggerService } from "shared/services/infrastructure/logger/logger.service";
import { IInitializable } from './initializable.interface';

export function initializeAppFunction(
  initializableServiceList: IInitializable[],
  userService: IUserService,
  authService: IAuthService) {
  LoggerService.initAsync();
  initializeServices(initializableServiceList);

  userService.userLoginByRefreshToken()
    .pipe(
      tap((token) => {
        let isLoginSuccessfull = authService.isAccessJWTValid(token);
        if (isLoginSuccessfull != true) {
          authService.accessJWTClear();
          userService.userLogout().subscribe();
          throw new Error("Login failed. JWT validation failed.");
        }
        authService.accessJWTSet(token);
      })
      ,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      catchError((err: any, caught: Observable<string>) => {
        // logout called in auth interceptor by handling the 401 response -> nope... doesn't... manually here required
        authService.accessJWTClear();
        userService.userLogout().subscribe();
        return EMPTY;
      })
    );
}

export function initializeServices(initializables: IInitializable[]) {
  initializables.forEach(svc => {
    if (typeof svc.init === 'function') {
      svc.init();
    } else {
      console.warn("initializable service found at startup without init() function. Please check the provider for", svc);
    }
  });
}
